import React, { Component } from "react";
import ReactDOM from 'react-dom';
import ReactQuill, { Quill, Mixin, Toolbar } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

/* Document: https://github.com/zenoamaro/react-quill */
export default class FreeFormTextArea extends Component {
    constructor(props) {
        super(props)
        this.state = { notes: '' }
    }

    // can not use componentWillMount *error will occur
    componentDidMount() {
        //console.log("Quill mounted!");
        var value = this.props.notes;
        this.setState({ notes: value })
    }

    componentWillUnmount() {
        //console.log("Quill unnn mounted!");
    }

    handleChange(value) {
        this.setState({ notes: value })
        this.props.handleNotesChange(value);
    }

    render() {
        /*var height = "250px";
        if(!isNaN(this.props.height)) {
            height = this.props.height;
        }*/

        return (
          <ReactQuill style       = {{ height: "250px", width: "560px" }}
                      value       = {this.state.notes || ""}
                      placeholder = "Write your notes here...."
                      bsSize      = "large"
                      onChange    = {this.handleChange.bind(this)} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/form/FreeFormTextArea.js